import login from '@/login'

// |--------------------------------------------------------------------------
// | KEEN ADAPTER
// |--------------------------------------------------------------------------

export async function listCachedDatasets(clients, types) {
  const result = {}

  for (const type of types) {
    const client = clients[type]
    const dataset = await client
      .get(client.url('datasets'))
      .auth(client.readKey())
      .send({ limit: 100 })

    result[`${type}Datasets`] = dataset

    if (dataset.count > 100) {
      const chunks = Math.ceil(dataset.count / 100)

      let datasets = dataset.datasets.slice()

      for (let step = 0; step < chunks; step++) {
        const datasetChunk = await client
          .get(client.url('datasets'))
          .auth(client.readKey())
          .send({ limit: 100, after_name: datasets.slice(-1)[0].dataset_name })

        datasets = datasets.concat(datasetChunk.datasets.slice())
      }
      dataset.datasets = datasets.slice()
    }
  }

  return result
}

export async function queryCachedDataset(client, name, idsArr, timeframe) {
  const indexBy = {}

  name = name.replace('channel', 'partner')

  idsArr.map((obj) => {
    if (obj.prop.includes('channel')) {
      obj.prop = obj.prop.replace('channel', 'partner')
    }

    indexBy[
      `${obj.prop.includes('id') ? 'custom_attributes.' : ''}${obj.prop}`
    ] = obj.value || 0 // HACK
  })

  name = 'V1_1___' + name
  if (login.canAnalyticsINTL()) {
    name = 'intl___' + name
  }

  const result = await client.query('dataset', {
    name: name,
    index_by: indexBy,
    timeframe: timeframe,
    zeroFill: false
  })

  return result
}

export async function getCachedDataset(client, name) {
  name = 'V1_1___' + name
  if (login.canAnalyticsINTL()) {
    name = 'intl___' + name
  }

  const dataset = await client
    .get(client.url('datasets', name))
    .auth(client.masterKey())
    .send()

  return dataset
}

export async function createCachedDataset(client, name, options) {
  name = 'V1_1___' + name
  if (login.canAnalyticsINTL()) {
    options.filters.push({
      operator: 'contains',
      property_name: 'custom_attributes.user_node_ids_encoded',
      property_value: ',20,'
    })
    options.display_name = 'INTL ' + options.display_name
    name = 'intl___' + name
  }

  // Hide free users' engagement with articles public versions for provider cached datasets
  if (
    ((options.group_by == 'custom_attributes.user_id' ||
      options.group_by == 'custom_attributes.notifiable_id') &&
      (options.index_by.includes('custom_attributes.channel_id') ||
        options.index_by.includes('custom_attributes.primary_analyst_id') ||
        options.index_by.includes('custom_attributes.alertable_id'))) ||
    (options.index_by.includes('custom_attributes.channel_id') &&
      options.index_by.includes('custom_attributes.user_id') &&
      options.index_by.length == 2)
  ) {
    if (
      !options.event_collection.includes('newsletter') &&
      !options.display_name.includes('newsletter')
    ) {
      options.filters.push({
        operator: 'ne',
        property_name: 'custom_attributes.article_version',
        property_value: 'public'
      })

      console.log('ADDED FILTER FOR ARTICLE_VERSION != PUBLIC')
    }
  }

  const queryBody = {
    display_name: options.display_name,
    query: {
      event_collection: options.event_collection,
      analysis_type: options.analysis_type,
      filters: options.filters,
      interval: options.interval,
      timeframe: options.timeframe
    },
    index_by: options.index_by
  }

  if (options.analyses && options.analysis_type === 'multi_analysis') {
    queryBody.query.analyses = options.analyses
  }

  if (options.group_by) {
    queryBody.query.group_by = options.group_by
  }


  try {

  const dataset = await client
    .put(client.url('datasets', name))
    .auth(client.masterKey())
    .send(queryBody)

  console.log('CREATED DATASET', queryBody, dataset)
  return dataset
  } catch(e){
    console.error('error', e)
  }
}

export async function deleteCachedDataset(client, name) {
  name = 'V1_1___' + name
  if (login.canAnalyticsINTL()) {
    name = 'intl___' + name
  }

  console.warn(
    'DANGER: DELETING CACHED DATASETS IS DISABLED, AS PRODUCTION DATA COULD BE AFFECTED. MANUAL OVERRIDE REQUIRED'
  )

  // return false

  console.log( client.masterKey())
  // if (name.includes("intl___")) {
  const dataset = await client
    .del(client.url('datasets', name))
    .auth(client.masterKey())
    .send()

  console.log('DELETED DATASET', name, 'FROM KEEN CLIENT', client)

  return dataset
  // }
}
